/* TWRD video-flise i produktgalleriet (snippets/twrd-gallery-video.liquid).
   - Spiller lydloest i loop, kun naar mindst 25 % af flisen er synlig.
   - Pauser udenfor skaermen, i skjult fane og naar flisen fjernes.
   - Pause-knappen (samme stil som why-sektionen) er brugerens valg: en video
     brugeren har sat paa pause, starter ikke igen af sig selv.
   - prefers-reduced-motion: ingen autoplay, knappen viser "play".
   - Galleriet bygges om ved farve/print-skift (twrd-variant-gallery.js), og
     Swiper paa telefon indsaetter slides som HTML-kopier. Derfor bindes nye
     <video data-twrd-gvideo> via en MutationObserver, og "bundet" holdes i et
     WeakSet, ikke i en attribut der ville blive kopieret med. */
(function () {
  'use strict';

  if (window.__twrdGalleryVideo) return;
  window.__twrdGalleryVideo = true;

  var SELECTOR = 'video[data-twrd-gvideo]';
  var VISIBLE_RATIO = 0.25;
  var bound = new WeakSet();
  var userPaused = new WeakSet();
  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (err) {
    reduceMotion = false;
  }

  function toggleOf(video) {
    var box = video.parentNode;
    return box ? box.querySelector('[data-twrd-gvideo-toggle]') : null;
  }

  function setLabel(video) {
    var button = toggleOf(video);
    if (!button) return;
    var playing = !video.paused;
    button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    button.setAttribute('data-state', playing ? 'playing' : 'paused');
  }

  function play(video) {
    video.muted = true;
    if (video.preload === 'none') video.preload = 'auto';
    var attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(function () {
        setLabel(video);
      });
    }
  }

  function pause(video) {
    if (!video.paused) video.pause();
  }

  /* Telefon-karrusellen bruger fade: alle slides ligger oven i hinanden paa
     x = 0, saa IntersectionObserver ser dem alle som synlige. Et slide i
     Swiper taeller derfor kun, naar det er det aktive. */
  function isActiveSlide(video) {
    var slide = video.closest ? video.closest('.swiper-slide') : null;
    return !slide || slide.classList.contains('swiper-slide-active');
  }

  function apply(video) {
    var visible = !!video.__twrdInView && isActiveSlide(video);
    if (!visible || document.hidden) pause(video);
    else if (!reduceMotion && !userPaused.has(video)) play(video);
  }

  function applyAll() {
    var list = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) apply(list[i]);
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var video = entries[i].target;
          video.__twrdInView = entries[i].isIntersecting && entries[i].intersectionRatio >= VISIBLE_RATIO;
          apply(video);
        }
      },
      { threshold: [0, VISIBLE_RATIO, 0.5] }
    );
  }

  /* Slide-skift paa telefon. Eventet bobler ikke, derfor capture. Swiper
     flytter swiper-slide-active i samme tick, vi venter en frame. */
  document.addEventListener(
    'on:media-carousel:slide-change',
    function () {
      window.requestAnimationFrame(applyAll);
    },
    true
  );

  function bind(video) {
    if (bound.has(video)) return;
    bound.add(video);
    video.muted = true;
    video.addEventListener('play', function () {
      setLabel(video);
    });
    video.addEventListener('pause', function () {
      setLabel(video);
    });
    setLabel(video);
    if (observer) observer.observe(video);
  }

  function scan() {
    var list = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) bind(list[i]);
  }

  document.addEventListener('click', function (e) {
    var button = e.target && e.target.closest ? e.target.closest('[data-twrd-gvideo-toggle]') : null;
    if (!button) return;
    var video = button.parentNode ? button.parentNode.querySelector(SELECTOR) : null;
    if (!video) return;
    e.preventDefault();
    e.stopPropagation();
    if (video.paused) {
      userPaused.delete(video);
      play(video);
    } else {
      userPaused.add(video);
      pause(video);
    }
  });

  document.addEventListener('visibilitychange', applyAll);

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
